import React from 'react';
import PropTypes from 'prop-types';
import Time from 'react-time';

import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';

import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import ArrowDropUpIcon from '@material-ui/icons/ArrowDropUp';

import DeviceHistoryExpanded from './device-histroy-expanded';

const DeviceHistoryListItem = (props) => {

  const itemDetails = () => {
    return (
      <ExpansionPanelDetails>
        {
          props.expanded
            ? (<DeviceHistoryExpanded uuid={props.uuid}/>)
            : (<div></div>)
        }
      </ExpansionPanelDetails>
    );
  };

  const itemSummary = () => {
    const txtList = [{ txt: props.uuid, width: 40 }, { txt: `${props.status[0].toUpperCase()}${props.status.slice(1)}`, width: 30 }];
    return (
      <ExpansionPanelSummary>
        {
          txtList.map(({ txt, width }, idx) => {
            return (
              <Typography key={idx} style={{ flexBasis: `${width}%`, textAlign: 'center' }}>{txt}</Typography>
            );
          })
        }
        <Typography style={{ flexBasis: '30%', textAlign: 'center' }}>
          <Time value={props.time} format="YYYY-MM-DD HH:mm" />
        </Typography>
        <IconButton className="expandButton">{props.expanded ? <ArrowDropUpIcon /> : <ArrowDropDownIcon />}</IconButton>
      </ExpansionPanelSummary>
    );
  };

  return (
    <ExpansionPanel className='deviceListItem' expanded={props.expanded}
      onChange={() => props.handleExpandDevice(props.idx)}>
      {itemSummary()}
      {itemDetails()}
    </ExpansionPanel>
  );
};

DeviceHistoryListItem.propTypes = {
  uuid: PropTypes.string.isRequired,
  time: PropTypes.string.isRequired,
  status: PropTypes.string.isRequired,
  expanded: PropTypes.bool.isRequired,
  idx: PropTypes.number.isRequired,
  handleExpandDevice: PropTypes.func.isRequired
};

export default React.memo(DeviceHistoryListItem);